const routes = {
  login: '/login',
  home: '/',
  productores: '/farmers',
  create: '/create',
  lotes: '/list',
  fincas: '/farms',
  catacion: '/cupping',
  certificacion: '/certification',
  trazabilidad: '/trazabilidad',
  search: '/search',
  notification: '/notification',

  cafepsaFarmers: '/farmers-module',
  cafepsaFarms: '/farms-module',
  cafepsaCertification: '/certification-module',
  cafepsaBatches: '/batches-module',
};





export default routes;
